import { render, staticRenderFns } from "./Bouteilles.vue?vue&type=template&id=45d204b2&"
import script from "./Bouteilles.vue?vue&type=script&lang=js&"
export * from "./Bouteilles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports